import React, { useContext, useEffect, useState } from 'react';

import { useNavigate} from "react-router-dom";

import CanvasJSChart from "./ReactCanvasJSChart";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import { getPanelHeader } from "./DashboardPanelFunctions";
import { getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import { getProviderSectionRAGStats } from "root/DataFunctions/ChartFns";

import { RagStatusValues } from "root/ReactHookForm/ui/ReactRAGStatus";
import GlobalContext, { useGlobalContext } from "root/Contexts/GlobalContext";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const getColorPoints = ( reportData, status ) =>
{
	const values = reportData.map ((row) =>
	{
		const scores = row.scores ;

		const count = scores.reduce((cur, rec) =>
		{
			if ( +(rec.status) === status)
			{
				cur = +(rec.count) ;
			}
			return cur ;
		}, 0);

		const label = row.section_name_abbrev === null ? ( 'S ' + row.table_section_id ) : row.section_name_abbrev ;

		return { label: label,
			y: count,
			provider_table_section_id: row.enc_provider_table_section_id,
			status: row.status
		}
	}) ;

	return values ;
}

export const getRAGDataPoints = ( reportData, onRowClick ) =>
{
	const amber = getColorPoints( reportData, RagStatusValues.AMBER );
	const red = getColorPoints( reportData, RagStatusValues.RED );
	const green = getColorPoints( reportData, RagStatusValues.GREEN );
	const unscored = getColorPoints( reportData, RagStatusValues.UNSET );

	const graphData = [
		{
			type: "stackedColumn",
			name: "Not Scored",
			showInLegend: false,
			color: "#f0f1f0",
			click: onRowClick,
			dataPoints: unscored,
		},
		{
			type: "stackedColumn",
			name: "Green",
			showInLegend: false,
			color: "#92D050",
			dataPoints: green,
		},
		{
			type: "stackedColumn",
			name: "Amber",
			showInLegend: false,
			color: "#FFC000",
			click: onRowClick,
			cursor: 'pointer',
			dataPoints: amber
		},
		{
			type: "stackedColumn",
			name: "Red",
			showInLegend: false,
			color: "#e63f22",
			click: onRowClick,
			cursor: 'pointer',
			dataPoints: red,
		},
	] ;

	return graphData ;
}

const DashboardPanelProviderRAGBarStats= ({provider_id, panelStyle='panel-default', survey_type, title='Title', id}) =>
{
	const [ data, setData ] = useState ( { loading: true, data: [], dataPoints: []})

	const navigate = useNavigate() ;

	const { getCustomObject } = useGlobalContext() ;

	useEffect(() =>
	{
		getServerData() ;
	}, []);

	const getColorForType = ( item ) =>
	{
		return  item.display_color === null ? "#2793e6" : item.display_color ;
	}

	const mapDataForDocType = ( arr ) =>
	{
		const dataPoints = arr === undefined  || arr.length === 0 ? [] : arr.map ( (item ) => {

			const obj = {} ;

			const key = item.monkey ;
			obj.y = +(item.numdocs) ;

			const yr = key.substr ( 0, 4 );
			const mo = key.substr (  4, 2 );

			obj.x =  new Date(yr,+mo-1) ;

			return obj ;
		})

		return dataPoints ;
	}

	const toolTipContent = (e) =>
	{
		const getMonthName = (month) =>
		{
			const monthNames = ["January", "February", "March", "April", "May", "June",
				"July", "August", "September", "October", "November", "December"
			];

			return monthNames[month];
		}

		let str = "";
		let total = 0;
		let str2, str3;
		for (var i = 0; i < e.entries.length; i++){
			var  str1 = "<span style= \"color:"+e.entries[i].dataSeries.color + "\"> "+e.entries[i].dataSeries.name+"</span>: <strong>"+e.entries[i].dataPoint.y+"</strong><br/>";
			total = e.entries[i].dataPoint.y + total;
			str = str.concat(str1);
		}
		str2 = "<span style = \"color:DodgerBlue;\"><strong>" + getMonthName((e.entries[0].dataPoint.x).getMonth()) + ' ' + (e.entries[0].dataPoint.x).getFullYear()+"</strong></span><br/>";
		total = Math.round(total * 100) / 100;
		str3 = "<span style = \"color:Tomato\">Total:</span><strong> "+total+"</strong><br/>";
		return (str2.concat(str)).concat(str3);
	}

	const onRowClick = ( e ) =>
	{
		/*const url = '/year/current/section/rag_report/' + e.dataPoint.id  ;
		/*const url = "/dashboard/rag_report/" + e.dataPoint.id ;*/
		const url = '/school/' + provider_id + '/dashboard/rag_report?provider_table_section_id=' + e.dataPoint.provider_table_section_id  ;

		navigate(url);
	}

	const getServerData = () =>
	{
		getProviderSectionRAGStats(provider_id, 'current', survey_type, (response) =>
		{
			const reportData = getDataFromResponse(response);

			const graphData = getRAGDataPoints ( reportData, onRowClick ) ;

			setData({loading: false, dataPoints: graphData, data: reportData }) ;
		});

	}

	const formPanel = () =>
	{
		const interval = getCustomObject( ConfigOptions.GRAPH_INTERVAL ) ;

		let options = {
			animationEnabled: true,
			height: 400,
			backgroundColor: "#FAFBFD",

			title: {
				text: "",
				fontColor: '#333',
				fontSize: 18,
				fontWeight: 'lighter',
				fontFamily: 'tahoma',
				padding: 20
			},
			axisX:{
				title:'',
				titleFontColor: '#333',
				titleFontSize: 14,
				titleFontFamily: 'tahoma',
				margin: 50,
				tickLength: 0
			},
			axisY: {
				title: "Questions",
				interlacedColor: "white",
				interval: interval,
				titleFontSize: 14,
				gridColor: "white",
				titleFontFamily: 'tahoma',
				tickLength: 0
			},
			legend: {
				verticalAlign: "center",
				horizontalAlign: "right",
				reversed: true,
				cursor: "pointer",
				fontSize: 16,
			},
			toolTip: {
				shared: true
			},

			data: data.dataPoints
		};

		return (
			<div className={'panel ' + panelStyle}>
				{ getPanelHeader({ title: title })}
				<div className='panel-body'>
					<CanvasJSChart id='chartProviderRag' options={options} uniqueId={'canvas'+ id}/>
				</div>
			</div>
		)
	}

	if ( data.loading === true )
	{
		return <SpinnerDiv/>
	}
	else
	{
		return formPanel() ;
	}

};

export default DashboardPanelProviderRAGBarStats;

